<div class="col-12 xl:col-12">
    <p-confirmDialog></p-confirmDialog>
    <div class="card">
        <p-toast
            position="top-center"
            key="confirm"
            [baseZIndex]="5000"
        ></p-toast>
        <div class="flex w-full justify-content-between align-items-center">
            <div
                class="flex w-full justify-content-start align-items-start flex-column"
            >
                <h4>{{ "VEHICLE_MAKES" | translate }}</h4>
                <p-inputGroup class="w-25rem" [formGroup]="searchForm">
                    <input
                        type="text"
                        pInputText
                        class="w-full"
                        (keydown.enter)="searchMakeClicked()"
                        (keyup)="searchMakeClicked()"
                        formControlName="search"
                        [placeholder]="'SEARCH_BY_MAKE_NAME' | translate"
                    />
                </p-inputGroup>
            </div>

            <button
                type="button"
                (click)="addVehicleMakeClicked()"
                pButton
                class="p-button p-button-primary w-10rem"
                icon="pi pi-plus"
                [label]="'NEW_MAKE' | translate"
            ></button>
        </div>
        <p-divider></p-divider>

        <div class="panels-container py-2">
            <div class="flex flex-column justify-content-center">
                <p-panel
                    [toggleable]="true"
                    [collapsed]="isPanelCollapsed(i)"
                    collapseIcon="pi pi-chevron-down"
                    expandIcon="pi pi-chevron-up"
                    *ngFor="let make of vehicleMakes; let i = index"
                    class="my-2"
                    (onBeforeToggle)="fetchMakeModels(make.id, i)"
                >
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center gap-3 my-2">
                            <img
                                src="assets/demo/images/transport.png"
                                alt="wise-logo"
                                style="width: 2.25rem"
                            />
                            <div class="make-detail">
                                <span class="font-bold">{{ make.name }}</span>
                                <!-- <div class="model-stats mt-1 flex align-items-center jystify-content-start gap-2" *ngIf="vehicleModels">
                                    <span class="badge font-bold">{{vehicleModels.length}}</span>
                                    <small class="text-600">Models Found</small>
                                </div> -->
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="icons">
                        <p-button
                            icon="pi pi-plus-circle"
                            [outlined]="true"
                            class="mr-3"
                            (onClick)="addVehicleModelClicked(make.id)"
                            [rounded]="true"
                            [label]="'ADD_MODEL' | translate"
                            [text]="true"
                        />
                    </ng-template>

                    <div>
                        <div
                            class="chips-container flex flex-wrap"
                            *ngIf="vehicleModels"
                        >
                            <p-chip
                                class="!py-0 !pl-0 !pr-4 flex-3 px-2 py-2 custom-chip"
                                [removable]="false"
                                removeIcon="pi pi-trash"
                                *ngFor="let model of vehicleModels"
                                (onRemove)="
                                    deleteModel(
                                        i,
                                        model.id,
                                        model.name,
                                        model.make.id,
                                        model.make.name
                                    )
                                "
                            >
                                <div class="flex">
                                    <!-- <span
                                        class="font-bold text-xl flex items-center mx-2 my-1 justify-center"
                                    >
                                        {{ model.name[0] }}
                                    </span> -->
                                    <p-button
                                        size="small"
                                        icon="pi pi-trash"
                                        (onClick)="
                                            deleteModel(
                                                i,
                                                model.id,
                                                model.name,
                                                model.make.id,
                                                model.make.name
                                            )
                                        "
                                        severity="danger"
                                        [rounded]="true"
                                        [text]="true"
                                    />
                                </div>
                                <span class="ml-2 font-medium">
                                    {{ model.name }}
                                </span>
                            </p-chip>
                        </div>
                    </div>
                </p-panel>
            </div>
        </div>
    </div>
</div>
